import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {

  @Input()
  showBackIcon: boolean = true;

  constructor(
    private location: Location,
  ) {
  }

  ngOnInit(): void {
  }
  
  goBack(): void {
    this.location.back();
  }
  
}
